import { messageCard } from "../message-card/MessageCard";

const Error404 = () => messageCard.error({ title: "Sayfa Bulunamadı" });

export default Error404;
